import { useSelector } from "react-redux"
import { SalesState } from "../state/reducer"
import { State } from "../../../state"
import { bindActionCreators } from "redux"
import { useDispatch } from "react-redux"
import * as actionCreators from '../state/actionCreators'
import { DocumentFooters, DocumentKey, DocumentPaymentTypeIds, Settings, SettingsModule, useAdministrationState } from "../../administration"
import { CustomerType } from "../state/types"
import { normalize } from "../../../utils/typeUtils"
import { DataType } from "../../../tables"
import { O, useFiltersHooks } from "../../../features/ui"

export const useSalesState = (): SalesState => useSelector((state: State) => state.salesReducer)

export const useSalesStateActions = () => bindActionCreators(actionCreators, useDispatch())

export const useSalesHooks = () => {
    const { sales, hoards } = useSalesState()
    const { settings } = useAdministrationState()
    
    const { search } = useFiltersHooks()

    const getSettings = (): O<Settings> => settings.find(setting => setting.module === SettingsModule.SALES)

    const getDocumentFooter = (key: DocumentKey): O<string> => (getSettings()?.documentFooters as O<DocumentFooters>)?.[key]

    const getDocumentPaymentTypeIdsData = (key: DocumentKey) => (getSettings()?.documentPaymentTypeIds as O<DocumentPaymentTypeIds>)?.[key]

    const getBranchSales = (branchId: string) => sales.filter(sale => sale.branchId === branchId)

    const getBranchHoards = (branchId: string) => hoards.filter(hoard => hoard.branchId === branchId)

    const searchCustomerTypes = (
        customerTypes: CustomerType[],
        text = '',
        showAll = false
    ): CustomerType[] => {
        const valuesFn = (customerTypeDT: DataType) => {
            const { name } = customerTypeDT as CustomerType
            return [normalize(name)]
        }
        const sortFn = (customerTypeDT_A: DataType, customerTypeDT_B: DataType) => 
            (customerTypeDT_A as CustomerType).name.localeCompare((customerTypeDT_B as CustomerType).name)

        return search(customerTypes, valuesFn, sortFn, text, showAll) as CustomerType[]
    }

    return {
        getSettings,
        getDocumentFooter,
        getDocumentPaymentTypeIdsData,
        getBranchSales,
        getBranchHoards,
        searchCustomerTypes
    }
}
